import { createContext, useContext } from 'react';

export interface AuthCheckState {
  authChecked: boolean;
  ensureAuthChecked: () => void;
}

// ADR-0013
export const AuthCheckContext = createContext<AuthCheckState>({
  authChecked: true,
  ensureAuthChecked: () => {},
});

export const useAuthCheck = (): AuthCheckState => useContext(AuthCheckContext);
